import { render } from "./IconFee.vue?vue&type=template&id=c8d8a350"
import script from "./IconFee.vue?vue&type=script&lang=js"
export * from "./IconFee.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconFee.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c8d8a350"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c8d8a350', __exports__)) {
    api.reload('c8d8a350', __exports__)
  }
  
  module.hot.accept("./IconFee.vue?vue&type=template&id=c8d8a350", () => {
    api.rerender('c8d8a350', render)
  })

}


export default __exports__